(function () {
  if (window.__CartShippingCalculatorBooted) return;
  window.__CartShippingCalculatorBooted = true;

  class CartShippingCalculator {
    constructor(instanceId) {
      this.instanceId = instanceId;
      this.init();
    }

    init() {
      this.bindEvents();
      this.setupInputMask();
      this.restoreZipcodeFromStorage();
    }

    bindEvents() {
      const calculateBtn = document.getElementById(`calculateShipping${this.instanceId}`);
      const zipcodeInput = document.getElementById(`zipcode${this.instanceId}`);

      if (calculateBtn && !calculateBtn.dataset.shippingCalcBound) {
        calculateBtn.dataset.shippingCalcBound = 'true';
        calculateBtn.addEventListener('click', () => this.calculateShipping());
      }

      if (zipcodeInput && !zipcodeInput.dataset.shippingCalcBound) {
        zipcodeInput.dataset.shippingCalcBound = 'true';

        zipcodeInput.addEventListener('keypress', (e) => {
          if (e.key === 'Enter') {
            this.calculateShipping();
          }
        });

        zipcodeInput.addEventListener('input', (e) => {
          this.formatZipcode(e.target);
        });
      }

      if (!window.__CartShippingCalculatorResizeBound) {
        window.__CartShippingCalculatorResizeBound = true;
        let resizeTimeout;
        window.addEventListener('resize', () => {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(() => {
            if (window.initCartShippingCalculators) {
              window.initCartShippingCalculators();
            }
          }, 250);
        });
      }
    }

    setupInputMask() {
      const zipcodeInput = document.getElementById(`zipcode${this.instanceId}`);
      if (zipcodeInput && !zipcodeInput.dataset.shippingCalcMask) {
        zipcodeInput.dataset.shippingCalcMask = 'true';
        zipcodeInput.addEventListener('input', (e) => {
          let value = e.target.value.replace(/\D/g, '');
          if (value.length > 5) {
            value = value.replace(/(\d{5})(\d)/, '$1-$2');
          }
          e.target.value = value;
        });
      }
    }

    formatZipcode(input) {
      let value = input.value.replace(/\D/g, '');
      if (value.length > 5) {
        value = value.replace(/(\d{5})(\d)/, '$1-$2');
      }
      input.value = value;
    }

    restoreZipcodeFromStorage() {
      const zipcodeInput = document.getElementById(`zipcode${this.instanceId}`);
      if (!zipcodeInput) return;

      const stored = window.localStorage.getItem('cep');
      if (!stored) return;

      zipcodeInput.value = stored;
      this.formatZipcode(zipcodeInput);

      /*
        Ate aqui so o campo voltava preenchido: endereco e opcoes de entrega
        sumiam a cada recarregamento, e a gaveta abria parecendo zerada.

        Refazer a conta e necessario, nao opcional: os valores dependem do que
        esta no carrinho, entao resultado guardado ficaria errado assim que a
        pessoa adicionasse ou tirasse um item.

        So que a gaveta existe no HTML de TODA pagina, mesmo fechada. Disparar
        no init custaria uma ida ao ViaCEP e outra a Shopify por pageview, para
        um painel que ninguem abriu. Por isso espera o bloco ficar visivel.
      */
      this.recalcularQuandoVisivel();
    }

    /*
      Cache do ultimo calculo.

      O que torna isso seguro e a ASSINATURA do carrinho gravada junto: total em
      centavos e quantidade de itens. Valor de frete depende do que esta dentro
      do carrinho, entao resultado guardado sem essa checagem viraria mentira na
      primeira vez que a pessoa adicionasse ou removesse um produto.

      Com a assinatura: bate, repoe na hora e nao gasta nenhuma requisicao de
      ViaCEP nem de frete; nao bate, recalcula do zero.
    */
    static get CHAVE_CACHE() { return 'frete_cache'; }

    async salvarCache(zipcode, addressData, shippingOptions) {
      try {
        // Le o carrinho agora: a assinatura precisa ser a do momento em que
        // estes valores de frete foram calculados, nao uma de antes.
        const carrinho = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
        window.__CartShippingLastCart = carrinho;

        window.localStorage.setItem(CartShippingCalculator.CHAVE_CACHE, JSON.stringify({
          cep: zipcode,
          endereco: addressData || null,
          opcoes: shippingOptions,
          total: carrinho.total_price,
          itens: carrinho.item_count,
          ts: Date.now()
        }));
      } catch (e) { /* localStorage cheio ou bloqueado: seguir sem cache */ }
    }

    lerCache(zipcode) {
      try {
        const bruto = window.localStorage.getItem(CartShippingCalculator.CHAVE_CACHE);
        if (!bruto) return null;
        const c = JSON.parse(bruto);
        if (!c || c.cep !== zipcode || !Array.isArray(c.opcoes) || !c.opcoes.length) return null;
        // 12 horas: tabela de frete muda, nao vale repor resultado de ontem
        if (!c.ts || Date.now() - c.ts > 12 * 60 * 60 * 1000) return null;
        return c;
      } catch (e) { return null; }
    }

    async reporDoCacheOuCalcular() {
      const zipcodeInput = document.getElementById(`zipcode${this.instanceId}`);
      const zipcode = zipcodeInput ? zipcodeInput.value.replace(/\D/g, '') : '';
      const cache = zipcode ? this.lerCache(zipcode) : null;

      if (!cache) return this.calculateShipping();

      let carrinho = null;
      try {
        carrinho = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
        window.__CartShippingLastCart = carrinho;
      } catch (e) { carrinho = null; }

      const mesmoCarrinho = carrinho
        && cache.total === carrinho.total_price
        && cache.itens === carrinho.item_count;

      if (!mesmoCarrinho) return this.calculateShipping();

      if (cache.endereco && cache.endereco.logradouro) this.showStreetName(cache.endereco);
      this.showShippingOptions(cache.opcoes);
    }

    recalcularQuandoVisivel() {
      const container = document.getElementById(`shippingCalculator${this.instanceId}`);
      if (!container || container.dataset.autoCalcBound) return;
      container.dataset.autoCalcBound = 'true';

      if (typeof IntersectionObserver === 'undefined') return;

      const obs = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          obs.disconnect();
          const resultados = document.getElementById(`shippingResults${this.instanceId}`);
          const jaTemResultado = resultados && resultados.style.display !== 'none';
          if (!jaTemResultado) this.reporDoCacheOuCalcular();
        });
      }, { threshold: 0.01 });

      obs.observe(container);
    }

    async calculateShipping() {
      const inputEl = document.getElementById(`zipcode${this.instanceId}`);
      if (!inputEl) return;

      const zipcode = inputEl.value.replace(/\D/g, '');

      if (!this.validateZipcode(zipcode)) {
        this.showError('Por favor, digite um CEP válido (8 dígitos)');
        return;
      }

      this.showLoading(true);
      this.hideError();
      this.hideResults();
      this.hideStreetName();

      try {
        const addressData = await this.fetchAddressData(zipcode);
        window.localStorage.setItem('cep', zipcode);

        /*
          Guarda tambem a UF. O ViaCEP ja devolve e ate agora ela era descartada.
          E o que permite a regua de frete gratis saber se a pessoa e de SP sem
          pedir o CEP de novo na pagina de produto.
        */
        if (addressData && addressData.uf) {
          window.localStorage.setItem('cep_uf', addressData.uf);
          if (addressData.localidade) {
            window.localStorage.setItem('cep_cidade', addressData.localidade);
          }
          document.dispatchEvent(new CustomEvent('cep:resolved', {
            detail: { uf: addressData.uf, cidade: addressData.localidade, cep: zipcode }
          }));
        } else {
          /*
            Resposta sem UF. Raro, mas o CEP acima ja foi gravado e passou a ser
            de outro lugar: deixar a UF anterior no armazenamento faria a regua
            de frete gratis continuar prometendo SP para quem acabou de informar
            outro estado — exatamente o que a restricao por regiao existe para
            impedir.

            Apagando, quem le a UF cai na tabela de faixas de CEP, que deduz o
            estado do proprio numero. O evento vai junto para a regua reavaliar
            na hora, sem esperar recarregamento.
          */
          window.localStorage.removeItem('cep_uf');
          window.localStorage.removeItem('cep_cidade');
          document.dispatchEvent(new CustomEvent('cep:resolved', {
            detail: { uf: '', cidade: '', cep: zipcode }
          }));
        }

        if (addressData && addressData.logradouro) {
          this.showStreetName(addressData);
        }

        const shippingOptions = await this.fetchShippingRates(zipcode, addressData);

        if (shippingOptions && shippingOptions.length > 0) {
          this.showShippingOptions(shippingOptions);
          this.salvarCache(zipcode, addressData, shippingOptions);
        } else {
          this.showError('Nenhuma opção de frete disponível para este CEP.');
        }
      } catch (error) {
        console.error('Erro ao calcular frete:', error);

        try {
          const shippingOptions = await this.fetchShippingRates(zipcode, null);
          if (shippingOptions && shippingOptions.length > 0) {
            this.showShippingOptions(shippingOptions);
          } else {
            this.showError('Erro ao consultar CEP e calcular frete. Tente novamente.');
          }
        } catch (shippingError) {
          this.showError('Erro ao consultar CEP e calcular frete. Tente novamente.');
        }
      } finally {
        this.showLoading(false);
      }
    }

    async fetchAddressData(zipcode) {
      try {
        const response = await fetch(`https://viacep.com.br/ws/${zipcode}/json/`);
        const data = await response.json();

        if (data.erro) {
          throw new Error('CEP não encontrado');
        }

        return data;
      } catch (error) {
        throw new Error('Erro ao consultar CEP');
      }
    }

    getBrazilStatesMap() {
      return {
        AC: 'Acre',
        AL: 'Alagoas',
        AP: 'Amapá',
        AM: 'Amazonas',
        BA: 'Bahia',
        CE: 'Ceará',
        DF: 'Distrito Federal',
        ES: 'Espírito Santo',
        GO: 'Goiás',
        MA: 'Maranhão',
        MT: 'Mato Grosso',
        MS: 'Mato Grosso do Sul',
        MG: 'Minas Gerais',
        PA: 'Pará',
        PB: 'Paraíba',
        PR: 'Paraná',
        PE: 'Pernambuco',
        PI: 'Piauí',
        RJ: 'Rio de Janeiro',
        RN: 'Rio Grande do Norte',
        RS: 'Rio Grande do Sul',
        RO: 'Rondônia',
        RR: 'Roraima',
        SC: 'Santa Catarina',
        SP: 'São Paulo',
        SE: 'Sergipe',
        TO: 'Tocantins',
      };
    }

    async fetchShippingRates(zipcode, addressData) {
      const states = this.getBrazilStatesMap();

      const country = 'Brazil';
      const zip = zipcode;

      let province;
      let city;

      if (addressData && addressData.uf) {
        province = states[addressData.uf] || addressData.uf;
        city = addressData.localidade;
      }

      const data = await this.fetchShopifyShippingRates({
        country,
        province,
        city,
        zip
      });
      const shippingRates = Array.isArray(data?.shipping_rates) ? data.shipping_rates : [];
      return this.normalizeShopifyRates(shippingRates);
    }

    async fetchShopifyShippingRates({ country, province, city, zip }) {
      const shippingData = {
        'shipping_address[country]': country,
        'shipping_address[zip]': zip,
      };

      if (province) shippingData['shipping_address[province]'] = province;
      if (city) shippingData['shipping_address[city]'] = city;

      const response = await fetch(`/cart/shipping_rates.json?${new URLSearchParams(shippingData).toString()}`);
      if (!response.ok) {
        throw new Error('Erro ao buscar opções de frete');
      }
      return response.json();
    }

    normalizeShopifyRates(shippingRates) {
      return shippingRates
        .map((rate) => {
          const priceNumber = this.parseShopifyPrice(rate?.price);
          const timeText = this.formatDeliveryTime(rate);

          return {
            name: rate?.name || 'Opção de frete',
            price: priceNumber,
            time: timeText || 'Prazo não informado',
          };
        })
        .filter((rate) => typeof rate.price === 'number');
    }

    parseShopifyPrice(price) {
      if (typeof price === 'number') return price;
      if (typeof price !== 'string') return 0;

      const normalized = price.replace(',', '.');
      const num = Number(normalized);
      return Number.isFinite(num) ? num : 0;
    }

    /*
      Monta o prazo em texto.

      Dois casos que a versao anterior errava, os dois visiveis na loja:

        0  ->  imprimia "0 dias uteis". E o Motoboy, que entrega no mesmo dia.
        1  ->  imprimiria "1 dias uteis", no plural errado.

      Shopify devolve o prazo como faixa [min, max]. Quando os dois sao iguais o
      texto precisa do singular, e o zero precisa de outra palavra: nao existe
      "zero dia util", existe entrega no mesmo dia.
    */
    formatDeliveryPhrase(min, max) {
      if (typeof min !== 'number' || typeof max !== 'number') return '';

      if (min === max) {
        if (min === 0) return 'no mesmo dia';
        if (min === 1) return '1 dia útil';
        return `${min} dias úteis`;
      }

      // Faixa começando em zero: "0 a 2 dias úteis" lê mal.
      if (min === 0) return `até ${max} ${max === 1 ? 'dia útil' : 'dias úteis'}`;

      return `${min} a ${max} dias úteis`;
    }

    formatDeliveryTime(rate) {
      /*
        Quando a transportadora manda uma descricao propria, ela ganha do prazo
        numerico. Nao e preferencia de estilo: no Motoboy os dois campos dizem
        coisas diferentes.

            delivery_days: [0, 0]
            description:   "Prazo de entrega até 24 horas após confirmação do pagamento"

        Zero dias vira "no mesmo dia"; a descricao fala em ate 24 horas apos a
        CONFIRMACAO DO PAGAMENTO, que pode cair no dia seguinte. E a descricao
        que o cliente le no checkout, entao e ela que vale aqui tambem, se nao a
        loja promete uma coisa na calculadora e outra na hora de pagar.

        Sedex e PAC vem com description nula e seguem pelo prazo numerico.
      */
      const descricao = (rate?.description || '').trim();
      if (descricao) return descricao;

      const deliveryDays = rate?.delivery_days;
      if (Array.isArray(deliveryDays) && deliveryDays.length >= 2) {
        const frase = this.formatDeliveryPhrase(deliveryDays[0], deliveryDays[1]);
        if (frase) return frase;
      }

      const deliveryRange = rate?.delivery_range;
      if (Array.isArray(deliveryRange) && deliveryRange.length >= 2) {
        const frase = this.formatDeliveryPhrase(deliveryRange[0], deliveryRange[1]);
        if (frase) return frase;
      }

      return '';
    }

    validateZipcode(zipcode) {
      return zipcode && zipcode.length === 8 && /^\d{8}$/.test(zipcode);
    }

    showLoading(show) {
      const button = document.getElementById(`calculateShipping${this.instanceId}`);
      if (!button) return;

      const buttonText = button.querySelector('.shipping-calculator__button-text');
      const loading = button.querySelector('.shipping-calculator__loading');
      if (!buttonText || !loading) return;

      if (show) {
        button.disabled = true;
        buttonText.style.display = 'none';
        loading.style.display = 'flex';
      } else {
        button.disabled = false;
        buttonText.style.display = 'inline';
        loading.style.display = 'none';
      }
    }

    showError(message) {
      const errorDiv = document.getElementById(`errorMessage${this.instanceId}`);
      const errorText = document.getElementById(`errorText${this.instanceId}`);

      if (errorDiv && errorText) {
        errorText.textContent = message;
        errorDiv.style.display = 'flex';
      }
    }

    hideError() {
      const errorDiv = document.getElementById(`errorMessage${this.instanceId}`);
      if (errorDiv) {
        errorDiv.style.display = 'none';
      }
    }

    showStreetName(addressData) {
      const streetDiv = document.getElementById(`streetName${this.instanceId}`);
      const streetText = document.getElementById(`streetNameText${this.instanceId}`);

      if (streetDiv && streetText) {
        const fullAddress = `${addressData.logradouro}, ${addressData.bairro} - ${addressData.localidade}/${addressData.uf}`;
        streetText.textContent = fullAddress;
        streetDiv.classList.add('show');
      }
    }

    hideStreetName() {
      const streetDiv = document.getElementById(`streetName${this.instanceId}`);
      if (streetDiv) {
        streetDiv.classList.remove('show');
      }
    }

    showShippingOptions(options) {
      const resultsDiv = document.getElementById(`shippingResults${this.instanceId}`);
      const optionsDiv = document.getElementById(`shippingOptions${this.instanceId}`);

      if (!resultsDiv || !optionsDiv) {
        return;
      }

      optionsDiv.innerHTML = '';

      if (!options || options.length === 0) {
        return;
      }

      options.forEach((option, index) => {
        const optionElement = this.createShippingOptionElement(option, index);
        optionsDiv.appendChild(optionElement);
      });

      resultsDiv.style.display = 'block';
      this.checkScrollNeeded();
    }

    createShippingOptionElement(option, index) {
      const div = document.createElement('div');
      div.className = 'shipping-calculator__option';
      div.style.animationDelay = `${(index + 1) * 0.1}s`;

      const name = option.name || 'Opção de frete';
      const time = option.time || 'Prazo não informado';
      const price = typeof option.price === 'number' ? option.price : 0;

      const priceText = price === 0 ? 'Grátis' : `R$ ${price.toFixed(2).replace('.', ',')}`;
      const priceClass = price === 0 ? 'free' : '';

      let icon = '🚚';
      if (name.toLowerCase().includes('sedex')) {
        icon = '⚡';
      } else if (name.toLowerCase().includes('grátis') || price === 0) {
        icon = '🎁';
      } else if (name.toLowerCase().includes('pac')) {
        icon = '📦';
      }

      div.innerHTML = `\
      <div class="shipping-calculator__option-details">\
        <div class="shipping-calculator__option-name">${icon} ${name}</div>\
        <div class="shipping-calculator__option-time">${time}</div>\
      </div>\
      <div class="shipping-calculator__option-price ${priceClass}">${priceText}</div>\
    `;

      return div;
    }

    hideResults() {
      const resultsDiv = document.getElementById(`shippingResults${this.instanceId}`);
      if (resultsDiv) {
        resultsDiv.style.display = 'none';
      }
    }

    checkScrollNeeded() {
      const optionsDiv = document.getElementById(`shippingOptions${this.instanceId}`);
      if (!optionsDiv) return;

      if (window.innerWidth <= 768) {
        const hasScroll = optionsDiv.scrollHeight > optionsDiv.clientHeight;
        optionsDiv.classList.toggle('has-scroll', hasScroll);
      }
    }
  }

  function initAllInstances() {
    const calculators = document.querySelectorAll('.shipping-calculator[id^="shippingCalculator"]');
    calculators.forEach((calculator) => {
      if (calculator.dataset.initialized) return;

      const instanceId = calculator.id.replace(/^shippingCalculator/, '');
      const zipcode = document.getElementById(`zipcode${instanceId}`);
      const button = document.getElementById(`calculateShipping${instanceId}`);

      if (zipcode && button) {
        calculator.dataset.initialized = 'true';
        window.__CartShippingCalculatorInstances = window.__CartShippingCalculatorInstances || {};
        window.__CartShippingCalculatorInstances[instanceId] = new CartShippingCalculator(instanceId);
      }
    });
  }

  window.initCartShippingCalculators = initAllInstances;

  /*
    Religar a calculadora depois que o tema troca o HTML da gaveta.

    O corpo da gaveta e re-renderizado pelo servidor a cada mudanca do carrinho:
    o component-cart-drawer.js substitui o innerHTML de cada
    data-cart-dynamic-content. A calculadora mora la dentro, entao some junto e
    volta como markup novo, sem a marca de inicializada e sem ouvinte nenhum.

    So o eventBus nao da conta. O cart-drawer e esta calculadora escutam o MESMO
    update:cart:drawer, e quem assina primeiro roda primeiro: na pratica
    initAllInstances rodava ANTES da troca do HTML, encontrava a instancia velha
    ja marcada, pulava, e o markup novo nunca era ligado.

    Medido no tema publicado: depois de mudar a quantidade de um item, o botao
    Calcular nao fazia mais nada — nenhuma requisicao, nenhum resultado, nenhuma
    mensagem de erro. So voltava a funcionar recarregando a pagina.

    O observador de DOM nao depende de ordem de evento: assim que aparece no
    documento uma calculadora sem marca, ele liga. Os eventos abaixo ficam
    porque encurtam a espera quando a ordem ajuda.
  */
  function temCalculadoraSolta() {
    return !!document.querySelector(
      '.shipping-calculator[id^="shippingCalculator"]:not([data-initialized])'
    );
  }

  let initAgendado = null;
  function agendarInit() {
    if (initAgendado) return;
    initAgendado = setTimeout(() => {
      initAgendado = null;
      initAllInstances();
    }, 50);
  }

  if (window.MutationObserver) {
    new MutationObserver(() => {
      if (temCalculadoraSolta()) agendarInit();
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllInstances);
  } else {
    initAllInstances();
  }

  const bindEventBus = () => {
    if (!window.eventBus || window.__CartShippingCalculatorEventBusBound) return;
    window.__CartShippingCalculatorEventBusBound = true;

    window.eventBus.on('update:cart:drawer', agendarInit);
    window.eventBus.on('render:cart:drawer', agendarInit);
    window.eventBus.on('drawer:opened', (drawerEl) => {
      if (drawerEl && drawerEl.tagName && drawerEl.tagName.toLowerCase() === 'cart-drawer') {
        agendarInit();
      }
    });
  };

  bindEventBus();
  setTimeout(bindEventBus, 0);
})();
